const isProduction = process.env.NODE_ENV === 'production';
const debugEnabled = !isProduction && process.env.REACT_APP_ENABLE_CLIENT_LOGS === 'true';

const debugLog = (...args) => {
  if (debugEnabled) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

const infoLog = (...args) => {
  if (debugEnabled) {
    // eslint-disable-next-line no-console
    console.info(...args);
  }
};

const warnLog = (...args) => {
  if (debugEnabled) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

const errorLog = (...args) => {
  if (debugEnabled) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

const logger = {
  debug: debugLog,
  info: infoLog,
  warn: warnLog,
  error: errorLog,
};

export { debugLog, infoLog, warnLog, errorLog };
export default logger;
